<template>
  <div class="criterio-select-multiple">
    <span v-if="label" class="criterio-subtitle">{{ label }}</span>
    <v-menu ref="menu" v-model="menu" transition="scale-transition" max-height="300" width="260" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :disabled="loadingInitialState"
          :loading="loadingInitialState"
          :value="getLabel"
          outlined
          hide-details
          readonly
          v-bind="attrs"
          v-on="on"
          @click="menu = true"
        />
      </template>

      <v-card>
        <v-card-text>
          <div v-for="option in availableOptions" :key="option.value" cols="3" class="py-0">
            <v-checkbox
              v-model="selectedOptionsValues"
              :label="option.label"
              :value="option.value"
              multiple
              class="my-0 py-0"
              @change="$emit('change', $event)"
            ></v-checkbox>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
    <v-chip-group active-class="primary--text" column>
      <v-chip v-for="option in selectedOptions" :key="option.value" small close @click:close="removeOption(option)">
        {{ option.label }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data: () => ({
    selectedOptionsValues: [],
    loadingInitialState: false,
    menu: false,
  }),

  computed: {
    availableOptions() {
      return this.componentParams.options
    },
    getLabel() {
      if (this.selectedOptionsValues.length === this.availableOptions.length) return 'Todos'
      if (this.selectedOptionsValues.length > 1) return `${this.selectedOptionsValues.length} selecionados`
      if (!this.selectedOptionsValues.length) return '0 selecionados'
      const selectedIndex = this.availableOptions.findIndex((item) => item.value === this.selectedOptionsValues[0])
      return `${this.availableOptions[selectedIndex].label}`
    },
    selectedOptions() {
      return this.availableOptions.filter((option) => this.selectedOptionsValues.includes(option.value)).map(({ value, label }) => ({ value, label }))
    },
  },

  watch: {
    selectedOptionsValues() {
      this.$emit('input', { currentValue: this.selectedOptions, currentChildren: this.values[0], currentIndex: this.currentIndex })
      this.validate()
    },
  },

  async mounted() {
    if (this.initialValue && this.initialValue.length) {
      this.setInitialState(this.initialValue)
    }
    this.validate()
  },

  methods: {
    removeOption(item) {
      const index = this.selectedOptionsValues.indexOf(item.value)
      if (index >= 0) this.selectedOptionsValues.splice(index, 1)
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return Boolean(this.selectedOptionsValues && this.selectedOptionsValues.length)
    },

    setInitialState(selectedOptions) {
      this.selectedOptionsValues = selectedOptions.map((option) => option.value)
    },
  },
}
</script>

<style lang="scss">
.criterio-select-multiple {
  .select-container {
    padding: 0 15px;
  }
}
</style>
